import { createFeatureSelector, createSelector } from '@ngrx/store';
import { extensionRegisterFeatureKey, ExtensionRegisterState } from './extension-register.reducer';

const extensionRegisterSelector = createFeatureSelector<ExtensionRegisterState>(extensionRegisterFeatureKey);

export const selectFilters = createSelector(extensionRegisterSelector, (state) => {
   return state.filters;
});

export const selectExtensionTypeOption = createSelector(extensionRegisterSelector, (state) => {
   return state.extensionTypeOption;
});

export const selectExtensions = createSelector(extensionRegisterSelector, (state) => {
   return state.entities;
});
